module.exports = __webpack_public_path__ + "assets/img/hang1.0b73f6a1.png";